<template>
	<div class="update">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">礼品卡销售统计</h2>

		<div class="wrap">
			<div class="title">会员链接</div>
			<div class="list">
				<div class="item" v-for="item in 25">{{item}}</div>
			</div>
		</div>
	</div>
</template>

<script>
// import {   } from '@/utils/axios.js'

export default {
	name: 'mainGiftCardSales',
	data() {
		return {
			submiting: false, // 正在请求=
		};
	},
	mounted() {
	
	},
	components: {},
	watch: {
		
	},
	methods: {
		
	}
};
</script>

<style scoped>

.list {
	display: grid;
	grid-template-columns: auto auto auto auto;
	grid-template-rows: auto auto auto auto;
}

.item {
	height: 0.4rem;
	display: flex;
	align-items: center;
}
</style>
<style lang="scss" scoped>
.update {
	
}
</style>
